export default __webpack_public_path__ + "static/media/Warning-Filled Icon.311e9302.svg";